/**
 * Description: Form to display email and password for user to login
 * Author : Guryash Singh Dhall
 * From Scratch
 **/
import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Link from "@mui/material/Link";
import CssBaseline from "@mui/material/CssBaseline";
import LoginSideImage from "../assets/images/login-invest-smart.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { userCreds } from "../data/data";
import { Alert } from "@mui/material";

// Used Material UI Theme
const theme = createTheme();

export default function LoginPage(props) {
  const history = useHistory();

  const [error, setError] = useState("");

  // Validate all input before submitting

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = userCreds.find(
      (user) =>
        user.email === userInfo.email && user.password === userInfo.password
    );
    if (user) {
      if (user.userType === "entrepreneur") {
        history.push({
          pathname: "/enterpreneurHomePage",
          state: user,
        });
      } else {
        history.push({
          pathname: "/investorHomePage",
          state: user,
        });
      }
    } else {
      setError("Invalid Credentials!");
      return;
    }
  };

  const [userInfo, setUserInfo] = useState({
    email: "",
    password: "",
  });

  const onhandleChange = (name, value) => {
    setUserInfo({
      ...userInfo,
      [name]: value,
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexFlow: "row wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={false}
            sm={12}
            md={12}
            lg={7}
            xl={4}
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexFlow: "column",
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                alignItems: "center",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                sx={{
                  height: 279.6,
                  width: 420,
                  maxHeight: { xs: 233, md: 466 },
                  maxWidth: { xs: 350, md: 700 },
                }}
                alt="The house from the offer."
                src={LoginSideImage}
              />
            </Grid>
          </Grid>
          {/* </Box> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            component={Paper}
            elevation={6}
            square
            sx={{
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexFlow: "column",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  mt: 5,
                  // margin: "auto",
                  mx: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    m: 2,
                    bgcolor: "#194376",
                    height: 160,
                    width: 160,
                  }}
                >
                  <AccountCircleIcon sx={{ fontSize: 155 }} />
                </Avatar>
                <Box component="form" noValidate sx={{ mt: 1 }}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    value={userInfo.email}
                    autoComplete="email"
                    autoFocus
                    onChange={(e) => onhandleChange("email", e.target.value)}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    value={userInfo.password}
                    onChange={(e) => onhandleChange("password", e.target.value)}
                    autoComplete="current-password"
                  />
                  <Grid item xs={12}>
                    {error && <Alert severity="error">{error}</Alert>}
                  </Grid>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      bgcolor: "#194376",
                      width: "30%",
                    }}
                    onClick={(e) => handleSubmit(e)}
                  >
                    Sign In
                  </Button>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingBottom: 2,
                        }}
                      >
                        <Link
                          onClick={() => {
                            history.push("/signup");
                          }}
                          variant="body2"
                          style={{ cursor: "pointer" }}
                        >
                          {"Don't have an account? Sign Up"}
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </ThemeProvider>
  );
}
